import { mapParamsBySchema, mapRowsBySchema } from '../../../util';
import { apiRequest } from '../../../Services/Common/ApiRequest';
import Global from '../../../Services/Common/Global';
import { M_EIS_BASIC_Schema } from './M_EIS_BASIC_Schema';
import useSaveMutation from '../../../Hooks/apis/useSaveMutaion';
import useSearchMutaion from '../../../Hooks/apis/useSearchMutaion';

/** 사업장 관리자 정보 조회 GetCustManager (Global.urls.Utility.getCustManager) */
export const useSearch1 = (options = {}) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(
      M_EIS_BASIC_Schema.mapper.search1,
      context
    );
    return apiRequest('post', Global.urls.Utility.getCustManager, params);
  }, options);
};

/** 보호구 수령현황 조회 GetEisBasicR1 (Global.urls.EquipIssuanceStatus.getEisBasicR1) */
export const useSearch2 = (options = {}) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(
      M_EIS_BASIC_Schema.mapper.search2,
      context
    );
    return apiRequest('post', Global.urls.EquipIssuanceStatus.getEisBasicR1, params);
  }, options);
};

/** 보호구 지급 서명 저장 SaveEisBasicU1 (Global.urls.EquipIssuanceStatus.saveEisBasicU1) */
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, M_EIS_BASIC_Schema.mapper.save1);
    return apiRequest('post1', Global.urls.EquipIssuanceStatus.saveEisBasicU1, payload);
  }, options);
};
